import React from "react";
import { Link } from "react-router-dom";

export const ProductCataloguePage = ({ data }) => {
  return (
      <div id="product-catalogue" className="text-center" style={{ padding: "100px 0" }}>
        <div className="container">
          <div className="section-title">
            <h2>Product Catalogue</h2>
            <p>Innovative commercial equipment designed for efficiency and excellence.</p>
          </div>
          <div className="row">
            <div className="col-md-4 col-sm-6">
              <div className="product-item">
                <Link to="/product-catalogue/ultrasonic-deepfryer-ef-v-series">
                  <img src="/img/products/mp-ew7000.png" alt="Ultrasonic Deepfriyer EW7000 Series" style={{ maxWidth: "200px", marginBottom: "15px", cursor: "pointer" }} />
                </Link>
                <h3>Ultrasonic Deepfriyer EW7000 Series</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
  );
};